import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=2174f76f&"
import script from "./CreateCoupon.js?vue&type=script&lang=js&"
export * from "./CreateCoupon.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports